import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import CustomNavbar from '../CustomPermissions/CustomNavbar';
import { API_BASE_URL } from '../../config/api';

const AuditUserList = () => {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/Audit/users/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
            });
            setUsers(response.data.data || []);
            setFilteredUsers(response.data.data || []);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching audit users:', error);
            setIsLoading(false);
        }
    };

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        const filtered = users.filter((user) =>
            user.name.toLowerCase().includes(term) || user.username.toLowerCase().includes(term)
        );
        setFilteredUsers(filtered);
    };

    return (
        <div className="d-flex flex-column flex-md-row">
            <CustomNavbar />
            <div className="container-fluid" style={{ margin: '20px auto', padding: '0 15px' }}>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-4">
                    <h2 className="text-center text-blue-500">Audit Reports</h2>
                    <div className="d-flex w-100 justify-content-end">
                        <input
                            type="text"
                            placeholder="Search by Name or Username..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="form-control w-25 shadow-sm border-blue-500"
                            style={{ minWidth: '250px' }}
                        />
                    </div>
                </div>

                {isLoading ? (
                    <div className="text-center mt-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="overflow-x-auto mx-auto w-full shadow-sm rounded">
                        <table className="text-sm border-separate border-spacing-y-2 bg-white border-gray-300 w-full" style={{ width: '100%', minWidth: '90%' }}>
                            <thead className="table-dark">
                                <tr className="bg-blue-500 text-white">
                                    <th className="py-3 px-4 text-center rounded-tl">#</th>
                                    <th className="py-3 px-4">Name</th>
                                    <th className="py-3 px-4">Username</th>
                                    <th className="py-3 px-4 text-center">Status</th>
                                    <th className="py-3 px-4 text-center rounded-tr">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredUsers.length > 0 ? (
                                    filteredUsers.map((user, index) => (
                                        <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                                            <td className="py-3 px-4 border-b text-center">{index + 1}</td>
                                            <td className="py-3 px-4 border-b font-medium">{user.name}</td>
                                            <td className="py-3 px-4 border-b text-gray-600">{user.username}</td>
                                            <td className="py-3 px-4 border-b text-center">
                                                {user.has_audit ? (
                                                    <span className="badge bg-success py-2 px-3 rounded-pill text-xs">Profile Exists</span>
                                                ) : (
                                                    <span className="badge bg-warning text-dark py-2 px-3 rounded-pill text-xs">No Profile</span>
                                                )}
                                            </td>
                                            <td className="py-3 px-4 border-b text-center">
                                                <Link
                                                    to={`/audit-report/${user.id}`}
                                                    className="bg-blue-600 hover:bg-blue-800 text-white py-2 px-4 rounded shadow-sm text-decoration-none d-inline-block transition-colors"
                                                >
                                                    {user.has_audit ? 'View / Update' : 'Create Audit'}
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="py-4 text-center text-gray-500">
                                            No users found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AuditUserList;
